import { Link } from 'react-router-dom';
import { darkTheme, FONT } from '../../theme/tokens';

const t = darkTheme;

export function NotFoundPage() {
  return (
    <div
      style={{
        minHeight: '100%',
        fontFamily: FONT,
        background: t.bg,
        padding: '32px',
      }}
    >
      <div style={{ maxWidth: 560, margin: '0 auto' }}>
        <h1
          style={{
            color: t.text,
            fontSize: 24,
            fontWeight: 600,
            margin: '0 0 16px 0',
          }}
        >
          Page not found
        </h1>
        <div
          role="alert"
          style={{
            padding: '20px 24px',
            background: t.surface,
            border: `1px solid ${t.border}`,
            borderRadius: 10,
            color: t.text2,
          }}
        >
          <div style={{ fontSize: 14, lineHeight: 1.55, marginBottom: 14 }}>
            That URL doesn't match any page in EKOM. It may have been moved or never existed.
          </div>
          <Link
            to="/"
            style={{
              color: t.accent,
              fontSize: 13,
              fontWeight: 500,
              textDecoration: 'none',
            }}
          >
            ← Back to Chat
          </Link>
        </div>
      </div>
    </div>
  );
}
